import { render, staticRenderFns } from "./Expertise.vue?vue&type=template&id=7fb1af5d&scoped=true"
import script from "./Expertise.vue?vue&type=script&lang=js"
export * from "./Expertise.vue?vue&type=script&lang=js"
import style0 from "./Expertise.vue?vue&type=style&index=0&id=7fb1af5d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb1af5d",
  null
  
)

export default component.exports